module.exports = __webpack_public_path__ + "img/loginbg.f1817f33.jpg";